// assets/open-product-reviews.js
// This script listens for clicks on the "See Reviews" link and opens the details element with id "customProductReviews" when clicked.
document.addEventListener('DOMContentLoaded', function() {
  var seeReviewsLink = document.querySelector('.rating__count a[href="#customProductReviews"]');
  var detailsEl = document.getElementById('customProductReviews');
  if (seeReviewsLink && detailsEl) {
    seeReviewsLink.addEventListener('click', function(event) {
      event.preventDefault();
      detailsEl.open = true;
      detailsEl.scrollIntoView({ behavior: 'smooth' });
    });
  }
}); 